import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {AdminService} from '../../services/admin.service';
import {Course} from "../../../shared/SharedEntities";

@Component({
  selector: 'app-course-dialog',
  templateUrl: './course-dialog.component.html',
  styleUrls: ['./course-dialog.component.scss']
})
export class CourseDialogComponent {
  courseForm: FormGroup;
  isEditMode: boolean;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<CourseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { course: Course | null }
  ) {
    this.isEditMode = !!data.course;
    this.courseForm = this.fb.group({
      name: [data.course?.name || '', Validators.required],
      startDateOfApplication: [data.course?.startDateOfApplication || '', Validators.required],
      endDateOfApplication: [data.course?.endDateOfApplication || '', Validators.required],
    });
  }

  onSave(): void {
    if (this.courseForm.valid) {
      const {startDateOfApplication, endDateOfApplication, ...rest} = this.courseForm.value;

      const courseData = {
        ...rest,
        startDateOfApplication: this.formatDate(startDateOfApplication),
        endDateOfApplication: this.formatDate(endDateOfApplication),
      };

      const request = this.isEditMode
        ? this.adminService.updateCourse(this.data.course!.id, courseData)
        : this.adminService.createCourse(courseData);

      request.subscribe({
        next: () => this.dialogRef.close(true),
        error: (error) => this.showError(error)
      });
    }
  }

  private showError(error: any): void {
    this.translate.get(['Error', 'An error occurred while saving the course.', 'OK']).subscribe(translations => {
      Swal.fire({
        title: translations['Error'],
        text: error?.error?.message || translations['An error occurred while saving the course.'],
        icon: 'error',
        confirmButtonText: translations['OK']
      });
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private formatDate(date: string | Date): string {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  }
}
